import React, { useState, useEffect, Fragment } from 'react';

import {
  Card, CardBody, CardTitle, Button, Modal, FormGroup, UncontrolledDropdown, DropdownToggle
  , ModalBody, ModalFooter, ModalHeader, Input, Row, Label, Col, DropdownItem, DropdownMenu, CustomInput
} from 'reactstrap';
import moment from 'moment';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { gAPI_Orders_Voucher, gAPI_Visitors, gAPI_Voucher_Payment, API_Order_Voucher_Notes } from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { uuid } from 'short-uuid';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import DatePicker from 'react-datepicker';

const UpdateStatus = ({
  data,
  orderId,
  user,
  handleReload
}) => {
  const [loading, setLoading] = useState(false);
  const [redeemAmount, setRedeemAmount] = useState(0);
  const [redeemType, setRedeemType] = useState('');
  const [updateModal, setUpdateModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [status, setStatus] = useState('NotRedeemed');
  const [reason, setReason] = useState('');
  const [visitorData, setVisiorData] = useState('');
  const [sessionDetails, setSessionDetails] = useState('');
  const [newStatus, setNewStatus] = useState('');
  const [emailData, setEmailData] = useState([]);
  const [voucherData, setVoucherData] = useState("");
  const [resendEmail, setResendEmail] = useState(false);
  const [settlementData, setSettlementData] = useState('');
  const [settlementModal, setSettlementodal] = useState(false);
  const [noteData, setData] = useState({
    notes: [],
    dates: []
  });
  const [noteModal, setNoteModal] = useState(false);
  const [note, setNote] = useState('');  
  const [error,setError]=useState('');  
  useEffect(() => {
    GetNotes(orderId);
    if (data.visitorId !== undefined && data.visitorId != '') {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Visitors}/visitors/${data.intregationId}?id=${data.visitorId}&group_id=${getGroupID()}`,
      })
        .then(res => {

          if (res.data.visitorId !== undefined) {
            setVisiorData(res.data);
            setSessionDetails(res.data.sessions[0]);
            //setSessionDetails(res.data.sessions.filter((f)=>f.id===data.sessionId).length>0 ?res.data.sessions.filter((f)=>f.id===data.sessionId)[0]:"");
          }
        })
        .catch(err => null);
    } else {
      setVisiorData('');
      setSessionDetails('');
    }
  }, [orderId]);
  const handleReconcilePyament = (data) => {
    AxiosAPI({
      method: 'post',
      url: `${gAPI_Voucher_Payment}/settlement`,
      data: { 'VoucherNumber': settlementData.voucherNumber, 'Amount': settlementData.amount, 'settlementDate': moment(settlementData.date).format('YYYY-MM-DD HH:mm:ss') }
    })
      .then((res) => {
        AddNote('Payment settlement done at ' + moment(settlementData.date).format('YYYY-MM-DD'));
        setSettlementodal(false);
        NotificationManager.success(
          '',
          'Payment settlement successfully done.',
          3000,
          null,
          null,
          'success'
        );
      })
  }
  const orderVoid = () => {
    AxiosAPI({
      method: 'put',
      url: `${gAPI_Orders_Voucher}/voucher/void`,
      data: { 'VoucherNumber': orderId, 'Reason': reason }
    })
      .then(res => {
        let name = user ? user.profile.name : "";
        AddNote(name + " changes order status " + data.redeem + " to " + newStatus);
      })
      .catch(err => null);

  };
  const AddNote = (note) => {
    AxiosAPI({
      method: 'post',
      url: `${API_Order_Voucher_Notes}`,
      data: { 'VoucherNumber': orderId, 'Notes': [{ 'Note': note, 'CreatedDate': moment().format('YYYY-MM-DD') }] }
    })
      .then(res => {
        setNoteModal(false);
      })
      .catch(err => null);

  };
  const GetNotes = () => {
    AxiosAPI({
      method: 'get',
      url: `${API_Order_Voucher_Notes}?voucherNumber=${orderId}`,
    })
      .then(res => {
        setData(res.data);
      })
      .catch(err => null);

  };
  const orderRefund = () => {
    AxiosAPI({
      method: 'put',
      url: `${gAPI_Orders_Voucher}/voucher/refund`,
      data: { 'VoucherNumber': orderId, 'Reason': reason }
    })
      .then(res => {
        let name = user ? user.profile.name : "";
        AddNote(name + " changes order status " + data.redeem + " to " + newStatus);
      })
      .catch(err => null);

  };
  const partialRedeem = () => {
    AxiosAPI({
      method: 'put',
      url: `${gAPI_Orders_Voucher}/voucher/refund`,
      data: { 'VoucherNumber': orderId, 'Reason': reason }
    })
      .then(res => {
        let name = user ? user.profile.name : "";
        AddNote(name + " changes order status " + data.redeem + " to " + newStatus);
      })
      .catch(err => null);

  };
  const handleSubmit = () => {
    switch (status) {
      case "Void":
        orderVoid();
        setNewStatus('Void');
        break;
      case "Refund":
        orderRefund();
        setNewStatus('Refunded');
        break;
      case "Redeem":
        if (data.isCard != undefined && data.isCard == true) {
          if (redeemType === 0) {
            console.log(redeemAmount);
            handleCardRedeem('0', redeemAmount);
          } else {
            handleCardRedeem('0', redeemAmount);
          }
        }
        else {
          handleRedeem('0');
          setNewStatus('Redeemed');
        }
        break;
      case "NotRedeemed":
        handleRedeem('2');
        setNewStatus('Available');
        break;
      default:
        break;
    }
    setUpdateModal(false);
  }

  const handleChange = (index, e) => {
    e.persist();
    const newItems = [...emailData];
    newItems[index]['email'] = e.target.value;
    setVoucherData(newItems);
  };
  const handleResendEmail = () => {
    AxiosAPI({
      method: 'put',
      url: `${gAPI_Orders_Voucher}/voucher/resend`,
      data: { 'VoucherNumber': orderId, 'Email': emailData.map((f) => f.email) }
    })
      .then((res) => {
        setEmailData([]);
        setResendEmail(false);
        let name = user ? user.profile.name : "";
        let email = "";
        if (emailData.length > 1)
            emailData.map((f) => email = email + "," + f.email)
        else
            emailData.map((f) => email = email + f.email)
        AddNote(name + " send email to " + email.trim(','));
        NotificationManager.success(
          '',
          'Email sent successfully.',
          3000,
          null,
          null,
          'success'
        );
      })
  };
  const handleRedeem = (status, value) => {
    let date = moment();
    let redeemdate = date.format('YYYY-MM-DD HH:mm:ss');
    AxiosAPI({
      method: 'PUT',
      url: `${gAPI_Orders_Voucher}/voucher/redeem?amount=${0}&id=00000000-0000-0000-0000-000000000000&voucherNumber=${orderId}&status=${status}&redeemDate=${redeemdate}`,
    })
      .then(res => {
        let name = user ? user.profile.name : "";
        AddNote(name + " changes order status " + data.redeem + " to " + (status == '0' ? 'Redeem' : 'Available'));
      })
      .catch(err => null);
    GetNotes();
  };

  const handleCardRedeem = (status, amount) => {
    let date = moment();
    let redeemdate = date.format('YYYY-MM-DD HH:mm:ss');    
    if (data.isCard === true && ((data.balance - redeemAmount) === 0 || redeemType == '0'))
      status = '0';
    AxiosAPI({
      method: 'PUT',
      url: `${gAPI_Orders_Voucher}/voucher/redeem?amount=${amount}&id=00000000-0000-0000-0000-000000000000&voucherNumber=${orderId}&status=${status}&redeemDate=${redeemdate}`,
    })
      .then(res => {
        let name = user ? user.profile.name : "";
        if (data.isCard === true && redeemAmount === data.balance)
          AddNote(name + " changes order status " + data.redeem + " to " + (status == '0' ? 'Redeem' : 'Available'));
        if (data.isCard === true) {
          if (redeemType === 0)
            AddNote('User ' + name + ' redeemed the Gift Card in full for $' + data.balance + ', remaining balance 0.');
          else
            AddNote('User ' + name + ' partially redeemed the Gift Card in full for $' + data.balance + ', remaining balance $' + (data.balance - redeemAmount) + '.');
        }
        // handleReload();
        GetNotes();
      })
      .catch(err => null);
  };

  const deleteEmail = (id) => {
    let email = emailData.filter((f) => f.id !== id);
    setEmailData(email);
  };
  const addEmailData = () => {
    let data = [...emailData];
    data.push({
      id: uuid(),
      email: '',
      disable: false
    });
    setEmailData(data);
  }
  return (
    <Fragment>
      <Card
        className="cardHeight mb-2 col-sm-12 col-md-4"
        style={{ overflow: 'scroll' }}
      >
        <CardBody>
          <Card
          >
            <CardBody>
              <div className='mb-2'>
                <div className='col-md-12 details-heading'>
                </div>
              </div>


              {noteData.notesList != undefined && noteData.notesList.length > 0 && noteData.notesList.map((n) => {
                return (<Fragment>
                  <div className='mt-2 ml-3 mb-2  details-subheading' >
                    <b className='mb-2 d-flex'>{moment(n.createdDate).format('MMMM Do YYYY, h:mm:ss a')}</b>
                    {n.note.map((m) => <p className='mb-2 d-flex' style={{ color: 'black' }}>{m}</p>)
                    }
                  </div>
                </Fragment>);
              })}

              {newStatus !== '' && <span className='mt-2 ml-3 mb-2 d-flex  details-subheading' style={{ color: 'black' }}> Status is changed from {data.redeem === 'NotRedeemed' ? 'Available' : data.redeem} to {newStatus}</span>}
              {/* //  <Button onClick={() => setUpdateModal(true)} color="primary"> Update Status </Button> */}
              <div>
                <UncontrolledDropdown className="w-15 text-center w-sm-100" >
                  <DropdownToggle caret color="outline-dark" size="xs">
                    Actions
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem
                      key='1View'
                      onClick={() => setUpdateModal(true)}
                    >
                      Update Status
                    </DropdownItem>
                    <DropdownItem
                      key='3View'
                      onClick={() => setNoteModal(true)}
                    >
                      Add Note
                    </DropdownItem>

                    <DropdownItem
                      key='4View'
                      onClick={() => setResendEmail(true)}
                    >
                      Resend email
                    </DropdownItem>
                    <DropdownItem
                      key='5View'
                      onClick={() => {
                        setSettlementData({
                          ...settlementData, email: data.email,
                          voucherNumber: data.voucherNumber, saleDate: data.createdDate, amount: data.price
                        });
                        setSettlementodal(true);
                      }}
                    >
                      Reconcile Payment
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
              {/* <Button className="ml-2" onClick={() => setResendEmail(true)} color="primary"> Resend Email </Button>

              <Button className="ml-2" onClick={() => setNoteModal(true)} color="primary"> Add Note </Button> */}
            </CardBody>
          </Card>
          <Card className="mt-4">
            <CardBody>
              <CardTitle className="card-title-margin">Order Insights </CardTitle>
              <div className="d-flex flex-row pb-1">
                <div className="pl-3 pr-2">
                  <p className="mb-0 ">
                    <i className="demo-icon iconsminds-clock"></i>
                  </p>
                </div>
                <div className="pl-3 pr-2">
                  <p className="mb-0">
                    <Fragment>
                      {' '}
                      {moment(data.createdDate).format(
                        'dddd, DD MMMM YYYY'
                      )} at {moment(data.createdDate).format('h:mm a')}
                    </Fragment>
                  </p>
                </div>
              </div>
              {sessionDetails !== '' && sessionDetails.details.IpAddress !== '' &&
                sessionDetails.details.IpAddress !== null ? (
                <Fragment>
                  <div className="d-flex flex-row pb-1">
                    <div className="pl-3 pr-2">
                      <p className="mb-0 ">
                        <i className="demo-icon iconsminds-map-marker-2"></i>
                      </p>
                    </div>
                    <div className="pl-3 pr-2">
                      {sessionDetails.details.IpAddress !== '' ? (
                        <p className="mb-0 ">Near {sessionDetails.details.IpAddress.City},{" "}{sessionDetails.details.IpAddress.RegionName} </p>
                      ) : null}
                      {sessionDetails.details.IpAddress !== '' ? (
                        <p className="mb-0 text-semi-muted ">
                          This location is approximate and determined by IP
                          address ({sessionDetails.details.IpAddress.IpAddress})
                        </p>
                      ) : null}
                    </div>
                  </div>
                  {sessionDetails.details.IpAddress.Latitude !== undefined &&
                    sessionDetails.details.IpAddress.Latitude !== '' && (
                      <div className="d-flex flex-row pb-1">
                        <iframe
                          width="100%"
                          height="170"
                          frameborder="0"
                          scrolling="no"
                          marginheight="0"
                          marginwidth="0"
                          src={`https://maps.google.com/maps?q=${sessionDetails.details.IpAddress.Latitude},${sessionDetails.details.IpAddress.Longitude}&hl=es&z=14&output=embed`}
                        ></iframe>
                      </div>
                    )}
                </Fragment>
              ) : null}
            </CardBody>
          </Card>
          {(visitorData !== '' && visitorData.customerInfo !== undefined && visitorData.customerInfo !== null) && <Fragment>
            {(visitorData.customerInfo.email !== '' ||
              (
                visitorData.customerInfo.timeUtC !== '' &&
                visitorData.customerInfo.timeUtC !== null)) && (
                <div className="icon-row-item mt-4 mb-4">
                  <Card>
                    {visitorData.customerInfo !== null &&
                      <CardBody>
                        <CardTitle className="card-title-margin">Visitor Info </CardTitle>
                        {visitorData.customerInfo.email !== '' && (
                          <div className="d-flex flex-row pb-1">
                            <div className="pl-3 pr-2">
                              <p className="mb-0 ">
                                <i className="demo-icon iconsminds-at-sign"> </i>
                              </p>
                            </div>
                            <div className="pl-3 pr-2">
                              <p className="mb-0 ">
                                {visitorData.customerInfo.email}
                              </p>
                            </div>
                          </div>
                        )}
                        {
                          visitorData.customerInfo.timeUTC !== '' &&
                          visitorData.customerInfo.timeUTC !== null && (
                            <div className="d-flex flex-row pb-1">
                              <div className="pl-3 pr-2">
                                <p className="mb-0 ">
                                  <i className="demo-icon iconsminds-handshake"> </i>
                                </p>
                              </div>
                              <div className="pl-3 pr-2">
                                <p className="mb-0 ">
                                  Marketing Consent:
                                  {visitorData.customerInfo.consentGiven === 'true' ? (
                                    <span style={{ color: 'green', marginLeft: '5px' }}>
                                      {'Yes'}
                                    </span>
                                  ) : (
                                    <span style={{ color: 'red', marginLeft: '5px' }}>
                                      {'No'}
                                    </span>
                                  )}{' '}
                                  <span className='mt-1 d-flex'>
                                    (
                                    {moment(visitorData.customerInfo.timeUTC).format(
                                      'dddd, DD MMMM YYYY'
                                    )}{' '}
                                    {moment(visitorData.customerInfo.timeUTC).format(
                                      'h:mm a'
                                    )}
                                    )</span>
                                </p>
                              </div>
                            </div>
                          )}
                      </CardBody>}
                  </Card>
                </div>
              )}

            {sessionDetails !== '' && sessionDetails.details !== undefined &&
              sessionDetails.details.ClientInformation !== undefined && sessionDetails.details.ClientInformation !== null && (
                <div className="icon-row-item mb-4">
                  <Card>
                    <CardBody>
                      <CardTitle className="card-title-margin">Device Info </CardTitle>
                      <Fragment>
                        <div className="d-flex flex-row pb-1">
                          <div className="pl-3 pr-2">
                            <p className="mb-0 ">
                              <i className="demo-icon iconsminds-computer"> </i>
                            </p>
                          </div>
                          <div className="pl-3 pr-2">
                            <p className="mb-0 ">{sessionDetails.details.ClientInformation.Device !== (undefined && null) && sessionDetails.details.ClientInformation.Device.Family}</p>
                          </div>
                        </div>
                        <div className="d-flex flex-row pb-1">
                          <div className="pl-3 pr-2">
                            <p className="mb-0 ">
                              {' '}
                              <i className="demo-icon iconsminds-optimization"></i>
                            </p>
                          </div>
                          <div className="pl-3 pr-2">
                            <p className="mb-0 ">{sessionDetails.details.ClientInformation.String} browser</p>
                          </div>
                        </div>
                      </Fragment>
                    </CardBody>
                  </Card>
                </div>
              )}{' '}
          </Fragment>}
        </CardBody>
      </Card>
      {/* <Modal
        isOpen={updateModal}
        toggle={() => setUpdateModal(false)}
        size="lg"
        style={{ maxWidth: '40%' }}
      >
        <ModalHeader toggle={() => setUpdateModal(false)}><h3>Voucher Status</h3></ModalHeader>
        <ModalBody>
          <Row className="mb-2">
            <div className='col-md-12'>
              <Input
                type="select"
                value={status}
                name="status"
                onChange={(e) => setStatus(e.target.value)}
                placeHolder="Please select voucher status"
              >
                <option value="NotRedeemed">Available</option>
                <option value="Redeem">Redeem</option>
                <option value="Void">Void</option>
                <option value="Refund">Refund</option>
              </Input>
            </div>
          </Row>
          {(status === "Void" || status === "Refund") &&
            <Row>
              <div className='col-md-1'>
                <Label className="mt-2 mr-2">Reason</Label>
              </div>
              <div className='col-md-12'>
                <Input type="text" value={reason} onChange={(e) => setReason(e.target.value)}>
                </Input>
              </div>
            </Row>}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => { handleSubmit(); }}>
            Save
          </Button>
          <Button onClick={() => setUpdateModal(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal> */}
      <Modal
        isOpen={updateModal}
        toggle={() => setUpdateModal(false)}
        size="lg"
        style={{ maxWidth: '40%' }}
      >
        <ModalHeader toggle={() => setUpdateModal(false)}><h3>Voucher Status</h3></ModalHeader>
        <ModalBody>
          {data.isCard === true && <Row className="mb-2">
            <div className='col-md-12'>
              <b>Balance: $<span className=''>{data.balance}</span></b>
            </div>
          </Row>}
          <Row className="mb-3">
            <div className='col-md-12'>
              <Input
                type="select"
                value={status}
                name="status"
                onChange={(e) => setStatus(e.target.value)}
                placeHolder="Please select voucher status"
              >
                <option value="NotRedeemed">Available</option>
                <option value="Redeem">Redeem</option>
                <option value="Void">Void</option>
                <option value="Refund">Refund</option>
              </Input>
            </div>
          </Row>

          {data.isCard === true && <Fragment>
            {status === "Redeem" && <Row className="mb-2 ml-3 my-2">
              <div className='col-md-6'>
                <CustomInput
                  type="radio"
                  id="exCustomRadio"
                  name="customRadio"
                  label="Fully Redeem"
                  checked={redeemType == "0"}
                  onChange={() => {
                    setRedeemAmount(data.balance);
                    setRedeemType(0);
                  }}
                />
              </div>
              <div className='col-md-6'>
                <CustomInput
                  type="radio"
                  id="exCustomRadio"
                  name="customRadio"
                  label="Partially Redeem"
                  checked={redeemType == "1"}
                  onChange={() => {
                    setRedeemAmount(0);
                    setRedeemType(1);
                  }}
                />
              </div>
            </Row>}
            {status === "Redeem" && redeemType !== '' && <Row className="my-3 ml-2">
              <div className='d-flex ml-3 '>
                <b> Balance to Redeem</b>:{redeemType == 0 ? 
                <span className='ml-1'>${data.balance}</span> :
                  <Fragment> {data.balance > 0 ?<Fragment>
                    <Input className="ml-2" type="number" max={data != undefined && data.balance} value={redeemAmount} style={{ width: '30%' }}
                      onChange={(e) =>{
                        if(data.balance - e.target.value >= 0){
                           setRedeemAmount(e.target.value);
                           setError('');
                        }else{
                          setError('Amount should be equal or less than the Balance');
                        }

                      }} ></Input>{error !=='' &&  <span className='ml-2' style={{color:'red'}}>Amount should be equal or less than the Balance</span>}</Fragment>
                    : <span className='ml-1'>$0</span>}
                  </Fragment>}
              </div>

              <div className='col-md-12  my-3'>
                <b>Remaining Balance</b>:
                <span className='ml-2'>${data.balance - redeemAmount}</span></div>
            </Row>}
          </Fragment>}

          {(status === "Void" || status === "Refund") &&
            <Row>
              <div className='col-md-1'>
                <Label className="mt-2 mr-2">Reason</Label>
              </div>
              <div className='col-md-12'>
                <Input type="text" value={reason} onChange={(e) => setReason(e.target.value)}>
                </Input>
              </div>
            </Row>}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => { handleSubmit(); }}>
            Save
          </Button>
          <Button onClick={() => setUpdateModal(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={noteModal}
        toggle={() => setNoteModal(false)}
        size="lg"
        style={{ maxWidth: '40%' }}
      >
        <ModalHeader toggle={() => setNoteModal(false)}><h3>Add Notes</h3></ModalHeader>
        <ModalBody>
          <Row>
            <div className='col-md-1'>
              <Label className="mt-2 mr-2">Note</Label>
            </div>
            <div className='col-md-12'>
              <Input type="text" value={note} onChange={(e) => setNote(e.target.value)}>
              </Input>
            </div>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => { AddNote(user.profile.name + " has added this Note: " + note); }}>
            Save
          </Button>
          <Button onClick={() => setNoteModal(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={resendEmail}
        toggle={() => { setEmailData([]); setResendEmail(false) }}
        size="lg"
        style={{ maxWidth: '50%' }}
      >
        <ModalHeader toggle={() => { setEmailData([]); setResendEmail(false) }}><h3>Resend Email</h3></ModalHeader>
        <ModalBody>
          <div className="">
            <Row className="mb-2">
              <Colxx sm={12}>
                <h4>Email</h4>
              </Colxx>
              <Colxx sm={12}>
                {emailData.map((m, index) => (
                  <Row key={`${m}~${index}`}>
                    <Colxx sm={8} className="md-3">
                      <FormGroup>
                        <Input type="text" disabled={m.disable} value={m.email} onChange={(e) => {
                          handleChange(index, e);
                        }} />
                      </FormGroup>

                    </Colxx>
                    <Colxx sm={1} className="mb-3">
                      <div>
                        <Button
                          onClick={() => deleteEmail(m.id)}
                          color="secondary"
                          size="xs"
                          outline
                          style={{ margin: '6px' }}
                        >
                          X
                        </Button>
                      </div>
                    </Colxx>
                  </Row>
                ))}
              </Colxx>
              <Colxx sm={12} className="md-3">
                <Button
                  onClick={addEmailData}
                  color="primary"
                  size="xs"
                  outline
                  style={{ margin: '6px' }}
                >
                  + Add email
                </Button>
              </Colxx>
            </Row>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button onClick={() => { setEmailData([]); setResendEmail(false) }}>
            Cancel
          </Button>
          <Button color="primary" onClick={() => { handleResendEmail(); }}>
            Send
          </Button>
        </ModalFooter>
      </Modal>

      {/* Reconcile Payment Modal */}
      <Modal
        isOpen={settlementModal}
        toggle={() => setSettlementodal(false)}
        size="lg"
        style={{ maxWidth: '40%' }}
      >
        <ModalHeader toggle={() => setSettlementodal(false)}><div><h3>Reconcile Payment</h3>
          <p>Keep your records up to date. Mark the date you received the vouchers payment from <b>aiva</b>.
          </p>
        </div>
        </ModalHeader>
        <ModalBody><div className="">
          <div className='d-flex my-2 mb-3'>
            <span> <b>Voucher Number : {settlementData.voucherNumber !== undefined ? settlementData.voucherNumber : ""}</b></span>
            <span className='ml-2'><b> Customer : {settlementData.email !== undefined ? settlementData.email : ""}</b></span>
            <span className='ml-2'><b> Sale Date : {settlementData.saleDate !== undefined ? moment(settlementData.saleDate).format('YYYY-MM-DD HH:mm:ss') : ""}</b></span>
          </div>
          <FormGroup>
            <Label><b>Payment Date</b></Label>
            <DatePicker
              selected={settlementData.date}
              onChange={(e) => setSettlementData({ ...settlementData, date: e })}
              placeholderText="Select Date"
              dateFormat="DD/MM/YYYY"
            />
          </FormGroup>
          <FormGroup>
            <Label><b>Payment Amount</b></Label>
            <Input type="text" value={settlementData.amount} onChange={() => null} disabled={true}>
            </Input>
          </FormGroup>
        </div></ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => { handleReconcilePyament(); }}>
            Save
          </Button>
          <Button onClick={() => setSettlementodal(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default UpdateStatus;

